import { atomWithReset } from 'jotai/utils';
import { domain } from 'modules/data';

export interface CustomFieldsState {
    [fieldId: string]: domain.NetSuiteCustomField;
}

export const netSuiteCustomFieldsState = atomWithReset<CustomFieldsState>({});
